module.exports = __webpack_public_path__ + "static/aba91c5e951ff08e715faec914c2008d.svg";